import React from "react";
import { Route } from "react-router-dom";
import { Archive, ClipboardList, GanttChart, Home, Landmark, ShoppingCart } from "lucide-react";
import Dashboard from "@/pages/private/Dashboard";
import ConsultaUsuario from "@/pages/private/Usuario/Consulta";
import CadastroUsuario from "@/pages/private/Usuario/Cadastro";
import PrivateLayout from "@/components/layouts/privateLayout";
import CadastroAluno from "@/pages/private/Aluno/Cadastro";
import Logout from "@/pages/private/Logout";
import ConsultaAluno from "@/pages/private/Aluno/Consulta";
import ConsultaPagamento from "@/pages/private/Pagamento/Consulta";
import CadastroPagamento from "@/pages/private/Pagamento/Cadastro";
import ConsultaUnidade from "@/pages/private/Unidade/Consulta";
import CadastroUnidade from "@/pages/private/Unidade/Cadastro";
import ConsultaPeriodoLetivo from "@/pages/private/PeriodoLetivo/Consulta";
import CadastroPeriodoLetivo from "@/pages/private/PeriodoLetivo/Cadastro";
import ConsultaServico from "@/pages/private/Servico/Consulta";
import CadastroServico from "@/pages/private/Servico/Cadastro";
import ConsultaProduto from "@/pages/private/Produto/Consulta";
import CadastroProduto from "@/pages/private/Produto/Cadastro";
import ConsultaCategoriaProduto from "@/pages/private/CategoriaProduto/Consulta";
import CadastroCategoriaProduto from "@/pages/private/CategoriaProduto/Cadastro";
import ConsultaVenda from "@/pages/private/Venda/Consulta";
import CadastroVenda from "@/pages/private/Venda/Cadastro";
import ConsultaEspecifica from "@/pages/private/Especifica/Consulta";
import CadastroEspecifica from "@/pages/private/Especifica/Cadastro";
import ConsultaTurma from "@/pages/private/Turma/Consulta";
import CadastroTurma from "@/pages/private/Turma/Cadastro";
import ConsultaGradeHoraria from "@/pages/private/GradeHoraria/Consulta";
import CadastroGradeHoraria from "@/pages/private/GradeHoraria/Cadastro";
import ConsultaPerfil from "@/pages/private/Perfil/Consulta";
import CadastroPerfil from "@/pages/private/Perfil/Cadastro";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import RelGeral from "@/pages/private/Report/RelGeral";
import ListaAlunos from "@/pages/private/Report/ListaAlunos";
import DadosAlunos from "@/pages/private/Report/DadosAlunos";
import MasterSheet from "@/pages/private/Report/MasterSheet";
import RelOrcamentos from "@/pages/private/Report/RelOrcamentos";
import ConsultaCheque from "@/pages/private/Cheque";
import ConsultaDinheiro from "@/pages/private/Dinheiro";
import ConsultaCartao from "@/pages/private/Cartao";
import ConsultaBoleto from "@/pages/private/Boleto";
import ConsultaPix from "@/pages/private/Pix";
import ListaStift from "@/pages/private/Report/ListaStift";
import ListaTriEduc from "@/pages/private/Report/ListaTriEduc";
import ListaHikari from "@/pages/private/Report/ListaHikari";

const PRIVATE_PATHS = [
  {
    DASHBOARD: "/",
    key: 8,
    path: "/",
    icon: Home,
    Component: Dashboard,
  },
  {
    key: 7,
    path: "/usuario",
    Component: ConsultaUsuario,
  },
  {
    path: "/usuarios/cadastro",
    Component: CadastroUsuario,
  },
  {
    key: 5,
    path: "/alunos",
    Component: ConsultaAluno,
  },
  {
    path: "/aluno/cadastro",
    Component: CadastroAluno,
  },
  {
    path: "/aluno/:id",
    Component: CadastroAluno,
  },
  {
    key: 9,
    path: "/pagamentos",
    Component: ConsultaPagamento,
  },
  {
    path: "/pagamento/cadastro",
    Component: CadastroPagamento,
  },
  {
    path: "/pagamento/:id",
    Component: CadastroPagamento,
  },
  {
    key: 6,
    path: "/unidades",
    Component: ConsultaUnidade,
  },
  {
    path: "/unidade/cadastro",
    Component: CadastroUnidade,
  },
  {
    path: "/unidade/:id",
    Component: CadastroUnidade,
  },
  {
    // O `title` aqui é só documentação: quem aparece no sidebar é o Menu.Nome
    // vindo da API. Deste array o menu usa apenas `key` (id do menu) e `icon`.
    key: 1,
    icon: ShoppingCart,
    title: "Vendas",
  },

  {
    key: 2,
    icon: Landmark,
    title: "Financeiro",
  },
  {
    key: 3,
    icon: GanttChart,
    title: "Cadastros",
  },
  {
    key: 4,
    icon: Archive,
    title: "Relatórios 1",
  },
  {
    key: 33,
    path: "/venda-produto",
    Component: ConsultaVenda,
  },
  {
    path: "/venda-produto/cadastro",
    Component: CadastroVenda,
  },
  {
    path: "/venda-produto/:id",
    Component: CadastroVenda,
  },
  {
    path: "/usuarios/cadastro",
    Component: CadastroUsuario,
  },
  {
    path: "/usuarios/:id",
    Component: CadastroUsuario,
  },
  {
    path: "/logout",
    Component: Logout,
  },
  {
    key: 10,
    path: "/periodoletivo",
    Component: ConsultaPeriodoLetivo,
  },
  {
    path: "/periodoletivo/cadastro",
    Component: CadastroPeriodoLetivo,
  },
  {
    path: "/periodoletivo/:id",
    Component: CadastroPeriodoLetivo,
  },
  {
    key: 11,
    path: "/servico",
    Component: ConsultaServico,
  },
  {
    path: "/servico/cadastro",
    Component: CadastroServico,
  },
  {
    path: "/servico/:id",
    Component: CadastroServico,
  },
  {
    key: 30,
    path: "/produto",
    Component: ConsultaProduto,
  },
  {
    path: "/produto/cadastro",
    Component: CadastroProduto,
  },
  {
    path: "/produto/:id",
    Component: CadastroProduto,
  },
  {
    key: 31,
    path: "/categoria-produto",
    Component: ConsultaCategoriaProduto,
  },
  {
    path: "/categoria-produto/cadastro",
    Component: CadastroCategoriaProduto,
  },
  {
    path: "/categoria-produto/:id",
    Component: CadastroCategoriaProduto,
  },
  {
    key: 12,
    path: "/especifica",
    Component: ConsultaEspecifica,
  },
  {
    path: "/especifica/cadastro",
    Component: CadastroEspecifica,
  },
  {
    path: "/especifica/:id",
    Component: CadastroEspecifica,
  },
  {
    key: 13,
    path: "/turma",
    Component: ConsultaTurma,
  },
  {
    path: "/turma/cadastro",
    Component: CadastroTurma,
  },
  {
    path: "/turma/:id",
    Component: CadastroTurma,
  },
  {
    key: 19,
    path: "/gradehoraria",
    Component: ConsultaGradeHoraria,
  },
  {
    path: "/gradehoraria/cadastro",
    Component: CadastroGradeHoraria,
  },
  {
    path: "/gradehoraria/:id",
    Component: CadastroGradeHoraria,
  },
  {
    key: 14,
    path: "/perfil",
    Component: ConsultaPerfil,
  },
  {
    path: "/perfil/cadastro",
    Component: CadastroPerfil,
  },
  {
    path: "/perfil/:id",
    Component: CadastroPerfil,
  },
  {
    key: 16,
    path: "/rel-geral",
    Component: RelGeral,
  },
  {
    key: 17,
    path: "/lista-alunos",
    Component: ListaAlunos,
  },
  {
    key: 18,
    path: "/dados-alunos",
    Component: DadosAlunos,
  },
  {
    key: 20,
    path: "/cheques",
    Component: ConsultaCheque,
  },
  {
    key: 21,
    path: "/dinheiro",
    Component: ConsultaDinheiro,
  },
  {
    key: 22,
    path: "/cartao",
    Component: ConsultaCartao,
  },
  {
    key: 23,
    path: "/master-sheet",
    Component: MasterSheet,
  },
  {
    key: 24,
    path: "/boletos",
    Component: ConsultaBoleto,
  },
  {
    key: 34,
    path: "/pix",
    Component: ConsultaPix,
  },
  {
    key: 25,
    path: "/rel-orcamentos",
    Component: RelOrcamentos,
  },
  {
    // Cabeçalho do grupo Relatórios > Listas de Plataformas (sem rota própria).
    key: 26,
    icon: ClipboardList,
    title: "Listas de Plataformas",
  },
  {
    key: 27,
    path: "/lista-stift",
    Component: ListaStift,
  },
  {
    key: 28,
    path: "/lista-trieduc",
    Component: ListaTriEduc,
  },
  {
    key: 29,
    path: "/lista-hikari",
    Component: ListaHikari,
  },
];

const PrivateRoutes: React.FC = () => {
  return (
    <Route element={<PrivateLayout />}>
      {PRIVATE_PATHS?.map(({ path, Component, key }) => {
        if (!Component) return null;
        
        // Dashboard não precisa de proteção
        if (path === "/") {
          return <Route path={path} element={<Component />} key={path} />;
        }
        
        // Se tem key, é uma página de consulta que precisa de proteção
        if (key) {
          return (
            <Route 
              path={path} 
              element={
                <ProtectedRoute menuId={key}>
                  <Component />
                </ProtectedRoute>
              } 
              key={path} 
            />
          );
        }
        
        // Páginas de cadastro herdam a permissão da página de consulta correspondente
        const getMenuIdForCadastro = (path: string) => {
          if (path.includes('/usuario')) return 7;
          if (path.includes('/aluno')) return 5;
          if (path.includes('/pagamento')) return 9;
          if (path.includes('/unidade')) return 6;
          if (path.includes('/periodoletivo')) return 10;
          if (path.includes('/servico')) return 11;
          if (path.includes('/venda-produto')) return 33;
          if (path.includes('/categoria-produto')) return 31;
          if (path.includes('/produto')) return 30;
          if (path.includes('/especifica')) return 12;
          if (path.includes('/turma')) return 13;
          if (path.includes('/gradehoraria')) return 19;
          if (path.includes('/perfil')) return 14;
          return null;
        };
        
        const menuId = getMenuIdForCadastro(path);
        
        if (menuId) {
          return (
            <Route 
              path={path} 
              element={
                <ProtectedRoute menuId={menuId}>
                  <Component />
                </ProtectedRoute>
              } 
              key={path} 
            />
          );
        }
        
        // Logout não precisa de proteção
        if (path === "/logout") {
          return <Route path={path} element={<Component />} key={path} />;
        }
        
        return <Route path={path} element={<Component />} key={path} />;
      })}
    </Route>
  );
};

export { PRIVATE_PATHS };
export default PrivateRoutes;
